<template>
	<DialogFormDialog ref="dialog" :strings="strings" @reset="reset">
		<v-text-field
			v-model="values.name"
			:rules="[required]"
			:label="strings.nameLabel"
			type="text"
		/>

		<v-select
			v-model="values.type"
			:items="typeOptions"
			:rules="[required]"
			:label="strings.typeLabel"
			:disabled="!!values.id"
		/>

		<v-text-field
			v-model="values.identifier"
			:rules="[required]"
			:label="strings.idLabel"
			type="text"
		/>
	</DialogFormDialog>
</template>

<script>
import _ from "lodash";
import strings from "@/utils/strings";
import config from "@/../public/config.json";

const initData = () => ({
	typeOptions: config.personalDeviceTypes.map((value) => ({
		value,
		text: _.startCase(value),
	})),

	values: { name: null, type: null, identifier: null },
	required: (v) => !!v || "Required",
});

export default {
	data: initData,

	computed: {
		strings() {
			const _strings = strings.k4noc.moves.dialog.assoc;
			return this.values.id ? _strings.update : _strings.create;
		},
	},

	watch: {
		values: {
			deep: true,
			handler(newVal) {
				this.$refs.dialog.updateFormData(newVal);
			},
		},
	},

	methods: {
		reset() {
			Object.assign(this, initData());
		},

		pop(handler, assoc) {
			if (assoc) {
				this.values = assoc;
			}
			return this.$refs.dialog.pop(handler);
		},
	},
};
</script>
